import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import WarehouseRoundedIcon from '@mui/icons-material/WarehouseRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import ViewCarouselRoundedIcon from '@mui/icons-material/ViewCarouselRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';

export const adminSections = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/myadmin/dashboard',
    icon: <DashboardRoundedIcon />,
    description: 'Review overall store health, activity, and operational priorities.',
    stats: ['Revenue snapshot', 'Open tasks', 'Sales pulse'],
  },
  {
    id: 'categories',
    label: 'Categories',
    path: '/myadmin/categories',
    icon: <CategoryRoundedIcon />,
    description: 'Organize product families and storefront navigation.',
    stats: ['Category tree', 'Visibility controls', 'Sort order'],
  },
  {
    id: 'products',
    label: 'Products',
    path: '/myadmin/products',
    icon: <Inventory2RoundedIcon />,
    description: 'Create, update, and retire sellable items.',
    stats: ['Catalog updates', 'Pricing rules', 'Product media'],
  },
  {
    id: 'variants',
    label: 'Variants',
    path: '/myadmin/variants',
    icon: <TuneRoundedIcon />,
    description: 'Manage size, flavor, pack, and attribute-based combinations.',
    stats: ['Option sets', 'SKU mapping', 'Variant pricing'],
  },
  {
    id: 'inventory',
    label: 'Inventory',
    path: '/myadmin/inventory',
    icon: <WarehouseRoundedIcon />,
    description: 'Track stock positions, low-stock alerts, and replenishment plans.',
    stats: ['Current stock', 'Low inventory', 'Restock flow'],
  },
  {
    id: 'orders',
    label: 'Orders',
    path: '/myadmin/orders',
    icon: <ReceiptLongRoundedIcon />,
    description: 'Monitor new, packed, dispatched, and completed orders.',
    stats: ['Order queue', 'Fulfillment state', 'Payment review'],
  },
  {
    id: 'users',
    label: 'Users',
    path: '/myadmin/users',
    icon: <GroupRoundedIcon />,
    description: 'Manage customer accounts, admins, and access permissions.',
    stats: ['User roles', 'Account health', 'Permission review'],
  },
  {
    id: 'coupons',
    label: 'Coupons',
    path: '/myadmin/coupons',
    icon: <LocalOfferRoundedIcon />,
    description: 'Create promotional offers and control redemption behavior.',
    stats: ['Discount rules', 'Validity windows', 'Usage limits'],
  },
  {
    id: 'banners',
    label: 'Banners',
    path: '/myadmin/banners',
    icon: <ViewCarouselRoundedIcon />,
    description: 'Update promotional creatives across the storefront.',
    stats: ['Hero banners', 'Campaign slots', 'Publishing status'],
  },
  {
    id: 'delivery-slots',
    label: 'Delivery Slots',
    path: '/myadmin/delivery-slots',
    icon: <ScheduleRoundedIcon />,
    description: 'Set delivery windows, capacity, and cutoff timing.',
    stats: ['Slot setup', 'Capacity rules', 'Holiday blocks'],
  },
  {
    id: 'notifications',
    label: 'Notifications',
    path: '/myadmin/notifications',
    icon: <NotificationsActiveRoundedIcon />,
    description: 'Control customer alerts, admin updates, and message timing.',
    stats: ['Push content', 'Order alerts', 'Audience targeting'],
  },
  {
    id: 'reports',
    label: 'Reports',
    path: '/myadmin/reports',
    icon: <AssessmentRoundedIcon />,
    description: 'Analyze sales, demand, and performance trends.',
    stats: ['Revenue reports', 'Category trends', 'Export-ready views'],
  },
  {
    id: 'settings',
    label: 'Settings',
    path: '/myadmin/settings',
    icon: <SettingsRoundedIcon />,
    description: 'Configure the platform, permissions, and store preferences.',
    stats: ['Store config', 'Security setup', 'Operational defaults'],
  },
];

export function getAdminSection(sectionId) {
  return adminSections.find((section) => section.id === sectionId);
}
